import { CaretRight, Info } from "@phosphor-icons/react/dist/ssr";
import Link from "next/link";
import React from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export default function FloatingQuota({ quota, type }) {
  // Don't render if user has active subscription
  if (quota?.hasSubscription) {
    return null;
  }

  return (
    <div className='fixed overflow-hidden w-[360px] shadow-lg z-50 border rounded-lg bottom-5 right-5 bg-[#1C1C1E] border-white/15'>
      <div className='p-3 -mx-px -mt-px border rounded-lg shadow bg-[#252527] border-white/5'>
        <div className='flex items-center gap-2'>
          <p className='text-lg font-medium'>{type === 'startup' ? 'Startups' : type === 'investor' ? 'Investors' : 'Special Reports'}</p>
          {/* <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <span className='translate-y-px opacity-40'>
                  <Info />
                </span>
              </TooltipTrigger>
              <TooltipContent className='text-xs'>
                <p>You have {type !== 'startup' && type !== 'investor' ? 'read' : 'accessed'}:</p>
                <ul className='mt-1 space-y-0.5'>
                  {quota?.items?.map((item, index) => (
                    <li key={index}>
                      <Link href={item.url || '#'} className='underline'>
                        {item.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider> */}
        </div>
        <div className='flex items-center justify-between mt-3'>
          <div className='flex items-end gap-2.5'>
            <span className='text-3xl font-semibold opacity-40'>{quota?.used}</span>
            <span className='text-xl opacity-30'>/</span>
            <span className='text-3xl font-semibold'>{quota?.total}</span>
            <span className='text-xl font-medium'>{type !== 'startup' && type !== 'investor' ? 'Read' : 'Accessed'}</span>
          </div>
          <span className={`${
            quota?.remaining > 0 
              ? 'text-[#3FF375] bg-[#12C247]/20' 
              : 'text-[#F33F3F] bg-[#C21212]/20'
          } rounded-md px-2 py-1 font-medium text-xs`}>
            {quota?.remaining} Remaining
          </span>
        </div>

        <div className='relative h-1.5 mt-3 overflow-hidden rounded-full bg-white/5'>
          <div
            className='absolute inset-y-0 left-0 rounded-full bg-gradient-to-r from-orange-1 to-red-1'
            style={{ width: `${((quota?.used) / (quota?.total)) * 100}%` }}
          ></div>
        </div>
      </div>
      <Link
        href='/pricing'
        className='flex items-center gap-0.5 px-3 py-2.5 text-white/40 hover:underline hover:text-white'
      >
        <p className='text-xs font-medium'>
          Upgrade for uninterrupted experience!{" "}
          <span className='text-white underline'>
            Upgrade Now!
          </span>
        </p>
      </Link>
    </div>
  );
}
